import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { Button, Preloader } from 'components';
import { PhoneInput } from 'components/TextInput';

import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

class NumberForm extends React.Component {
  constructor() {
    super();
    this.state = {
      number: '',
      numberError: null,
    };
  }

  handleSubmit = (e) => {
    const { onSubmit } = this.props;
    const { number } = this.state;
    if (onSubmit) {
      e.preventDefault();

      /** only submit if number is valid */
      if (this.isNumberValid()) {
        onSubmit({ number });
      }
    }
  };

  handlePhoneChange = (number) => this.setState({ number, numberError: null });

  validateNumber = () =>
    this.setState({
      numberError: this.isNumberValid() ? null : 'Телефон не заполнен',
    });

  isNumberValid = () => /^9[0-9]{9}$/.test(this.state.number);

  render() {
    const { buttonText, isPending, isLight, isCompact } = this.props;
    const { number, numberError } = this.state;

    return (
      <form
        className={cx('form', { compact: isCompact, light: isLight })}
        onSubmit={this.handleSubmit}
        ref={(element) => {
          this.form = element;
        }}
      >
        <PhoneInput
          placeholder="Номер телефона"
          onBlur={this.validateNumber}
          onChange={this.handlePhoneChange}
          name="number"
          value={number}
          error={numberError}
          disabled={isPending}
          className={cx('inputField', 'marb-xxs')}
          keepErrorIndent={false}
        />
        {isPending ?
          <div className={cx('loader')}>
            <Preloader />
          </div>
        : <Button className={cx('button')} disabled={!this.isNumberValid()}>
            {buttonText}
          </Button>
        }
      </form>
    );
  }
}

NumberForm.propTypes = {
  buttonText: PropTypes.string,
  isLight: PropTypes.bool,
  isPending: PropTypes.bool,
  isCompact: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default NumberForm;
